(function () {
  "use strict";

  // Normalize /collections/{handle}/products/{handle} to /products/{handle}
  function canonicalizeAnchor(a) {
    try {
      if (!a || !a.href || (a.dataset && a.dataset.skipCanonicalization === "true")) return false;
      var rawHref = a.getAttribute("href");
      if (!rawHref || /^\s*#/.test(rawHref)) return false;

      var url = new URL(rawHref, document.baseURI);
      if (url.origin !== window.location.origin) return false;

      var path = url.pathname;
      if (/^\/products\//.test(path)) return false;

      var m = path.match(/^\/collections\/[^\/]+\/products\/([^\/?#]+)\/?$/);
      if (!m) return false;
      var productHandle = m[1];
      var newPath = "/products/" + productHandle;
      var newHref = newPath + url.search + url.hash;

      a.setAttribute("href", newHref);
      return true;
    } catch (e) {
      return false;
    }
  }

  function canonicalizeAll(root) {
    var scope = root || document;
    if (scope.nodeType === 1 && scope.matches && scope.matches('a[href]')) {
      canonicalizeAnchor(scope);
    }
    var anchors = scope.querySelectorAll('a[href]');
    for (var i = 0; i < anchors.length; i++) {
      canonicalizeAnchor(anchors[i]);
    }
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function(){ fn.apply(ctx, args); }, wait);
    };
  }

  function initObserver() {
    if (!window.MutationObserver) return;
    var pending = [];
    var flush = debounce(function () {
      var nodes = pending;
      pending = [];
      for (var i = 0; i < nodes.length; i++) {
        canonicalizeAll(nodes[i]);
      }
    }, 100);

    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (node && node.nodeType === 1) {
            pending.push(node);
          }
        }
      }
      flush();
    });
    obs.observe(document.documentElement || document.body, { childList: true, subtree: true });
  }

  function hookUSF() {
    try {
      if (window.usf && usf.event && typeof usf.event.add === 'function') {
        usf.event.add('sr_updated', function () {
          var container = document.getElementById('usf_container') || document;
          canonicalizeAll(container);
        });
      }
    } catch (e) { /* no-op */ }
  }

  function onReady(fn) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  onReady(function () {
    canonicalizeAll(document);
    initObserver();
    hookUSF();
    window.addEventListener('load', function(){
      setTimeout(function(){ canonicalizeAll(document); }, 0);
    });
  });
})();
